export default __webpack_public_path__ + "static/media/fossologyFlow.68031473.svg";